import StarRankSwiperDetailMenu from '@/components/starrank/menu/StarRankSwiperDetailMenu';
import {SoopUiImg} from '@/components/ui';
import {StarrankT} from '@/utils/i18n/starrank';
import {sendLegacyInflowPathLog} from '@/utils/main/my/log';
import classNames from 'classnames';
import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

/**
 * 별별랭킹 페이지 스와이퍼 영역 내부 슬라이드 아이템 컴포넌트
 *
 * @param {Object} props
 * @param {Object} props.broadItem Broadcast Item 객체
 * @param {function} props.onClickLaterViewBtn 나중에 보기 버튼 동작
 * @param {function} props.onMenuVisibilityChanged 메뉴 표시 여부가 변경될 때의 동작
 */
const StarRankSwiperItem = ({
  broadItem,
  onClickLaterViewBtn,
  onMenuVisibilityChanged,
}) => {
  const [isError, setIsError] = useState(false);

  const [thumbClass, setThumbClass] = useState('');

  const handleLiveImageError = () => {
    setIsError(true);
  };

  /**
   * 별별랭킹 스와이퍼 내부 라이브 진입 영역 클릭 시 처리
   */
  const handleOnClickLive = (broadcastId, streamerId) => {
    sendLegacyInflowPathLog({
      broadcastId,
      streamerId,
      isLogSendData: {
        path1: 'starrank',
        path2: 'top_list',
      },
    });
  };

  useEffect(() => {
    setThumbClass(
      classNames({
        'thumb-adult': Number(broadItem?.broadGrade) === 19,
        'thumb-default': isError,
      }),
    );
  }, [isError, broadItem?.broadGrade]);

  return (
    <>
      <div className='thumbs-box'>
        <Link
          to={broadItem?.url}
          target='_blank'
          className={thumbClass}
          onClick={() =>
            handleOnClickLive(broadItem?.broadNo, broadItem?.userId)
          }>
          {(Number(broadItem.subscriptionOnly) === 1 ||
            Number(broadItem.subscriptionOnly) === 2) && (
            <em class='_subscribe plus'>
              <span>{StarrankT('구독')}</span>
            </em>
          )}
          <SoopUiImg
            src={broadItem?.snUrl}
            onError={handleLiveImageError}
            isAdult={Number(broadItem?.broadGrade) === 19}
            alt='broadcast-thumbnail'
          />
        </Link>
        {broadItem?.visitBroadType === 1 ? (
          <span className='allow'>{StarrankT('탐방')}</span>
        ) : (
          <></>
        )}
        <span className='time'>
          {StarrankT('{{time}} 방송시작', {
            placeholder: {time: broadItem?.broadStart?.substring(5)},
          })}
        </span>
      </div>
      <div className='info-box'>
        <h3>
          <Link
            to={broadItem?.url}
            className='title'
            target='_blank'
            onClick={() =>
              handleOnClickLive(broadItem?.broadNo, broadItem?.userId)
            }>
            {broadItem?.broadTitle}
          </Link>
        </h3>
        <StarRankSwiperDetailMenu
          rankItem={broadItem}
          onMenuVisibilityChanged={onMenuVisibilityChanged}
        />
      </div>
    </>
  );
};

export default StarRankSwiperItem;
